import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { GET_POSTS_GQL } from '@/graphql/queries.gql';

export default {
  namespaced: true,

  state: {
    // = data
    posts: [],
  },

  mutations: {
    SET_POSTS(state, payload) {
      state.posts = payload;
    },
  },

  actions: {
    // = methods
    // destructuring `context.commit` by doing `{ commit }`
    getPosts({ commit }) {
      commit('shared/SET_LOADING', true, { root: true });

      apolloClient
        .query({
          query: GET_POSTS_GQL,
        })
        .then(({ data }) => {
          commit('SET_POSTS', data.posts);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
  },

  getters: {
    // = computed properties
    posts: state => state.posts,
  },
};
